<template>
  <div class="p-y-15 p-x-24" style="background: white;border-radius: 12px;">
    <!-- 头部 -->
    <tk-flex between class="p-b-24">
      <div class="font-14">商品库存</div>
      <tk-flex wrap :gutter="12">
        <!-- 战区 -->
        <selectWarzone @select="selectWarzone"></selectWarzone>
        <!-- 大区 -->
        <selectRegional type="regional" level="2" @select="selectRegional"></selectRegional>
        <!-- 系列 -->
        <selectSeries @select="selectValue"></selectSeries>
      </tk-flex>
    </tk-flex>
    <!-- 代理 -->
    <ak-model-table
      v-if="$store.state.user.level === '3' || $store.state.user.level === '4'"
      hideAction model="indexProductStockAgent"
      :hidePagination="true"
      :filters="filtersAgent"
      ref="indexProductStock"
      :perPage="10000"
      tableSize="small"
    />
    <!-- 总后台 大区 战区 -->
    <ak-model-table
      v-else
      model="indexProductStock"
      hideAction
      :hidePagination="true"
      :filters="filters"
      ref="indexProductStock"
      :perPage="10000"
      tableSize="small"
    />
  </div>
</template>
<script>
import selectSeries from './components/selectSeries.vue'
import selectWarzone from './components/selectWarzone.vue'
import selectRegional from './components/selectRegional.vue'
export default {
  components: {
    selectSeries,
    selectWarzone,
    selectRegional
  },
  data () {
    return {
      filters: {
        isCose: false,
        isDelete: false
      },
      filtersAgent: {
        isDelete: false
      }
    }
  },
  mounted () {
    if (this.$store.state.user.level === '3') {
      this.filtersAgent.winWinMerchant = this.$store.state.user.objectId
    }
    if (this.$store.state.user.level === '4') {
      this.filtersAgent.winWinMerchant = this.$store.state.user.agent
    }
  },
  methods: {
    selectValue (value) {
      console.log(value, 'value')
      if (value === 'all') {
        delete this.filters.series
        delete this.filtersAgent.commodity
        this.$refs.indexProductStock.refresh()
        return
      }
      this.filtersAgent.commodity = {
        $inQuery: {
          where: {
            series: value
          },
          className: 'commodity'
        }
      }
      this.filters.series = value
      this.$refs.indexProductStock.refresh()
    },
    selectWarzone (value) {
      this.$store.commit('setIndexSelectWarzone', value)
      this.$store.commit('setIndexSelectRegional', 'all')
      console.log(value, '战区')
    },
    selectRegional (value) {
      this.$store.commit('setIndexSelectRegional', value)
      console.log(value, '大区')
    }
  },
  beforeDestroy () {
    console.log('销毁销毁销毁销毁销毁销毁')
    this.$store.commit('setIndexSelectWarzone', null)
    this.$store.commit('setIndexSelectRegional', null)
  }
}
</script>
